<template>
<main class="G_DisplayColumnNowrap L_HomeMainHolder">
    <span class="G_DisplayRowNowrap L_HomeMainImageHolder">
        <img v-for="HomeImage in HomeImages" :key="HomeImage" :src="HomeImage" class="L_HomeImage" />
        <img :src="HomeImageMobile" class="L_HomeImageMobile" />
    </span>
    <div class="G_DisplayColumnNowrap L_HomeDescriptionHolder">
        <span class="G_HeadingFont L_HomeDescriptionHeading">
            Tania's Sweet Treats
        </span>
        <div class="L_HomeDescriptionImageText">
            <span class="L_HomeDescriptionImage"><img :src="TaniaImage" class="G_BorderRadius L_TaniaImage" /></span>
            <span class="G_NormalFont L_HomeDescriptionText">
                Tania's Sweet Treats was established in 2019 and has been growing ever since! I started this business as a little hobby after
                making fudge for family and friends but have since expanded to customers all over South Africa. I learned from my father and
                from there on I created my own recipes. Our fudge is made by combining the best ingredients such as real butter, lots of passion
                and love. Upon arrangement all our sweet treats can be couriered at a minimal fee. Our irresistible treats are always a huge hit
                and promise not to disappoint. Although we have an existing range we are experimenting to bring you more exciting treats. Please
                check out our Facebook page for more exciting updates! We have a wide variety of fudge and other sweet treats. We cater for weddings,
                tuckshops and any other special needs you might have.
            </span>
        </div>
    </div>
    <div class="G_DisplayColumnNowrap L_ReviewHolder">
        <div class="G_HeadingFont G_DisplayRowNowrap L_ReviewHeading">
            What our customers say.
        </div>
        <div class="G_NormalFont L_ReviewItems">
            <div class="G_DisplayRowNowrap L_ReviewItem" v-for="ReviewItem in ReviewItems" :key="ReviewItem">{{ ReviewItem.ReviewItem }}</div>
        </div>
    </div>
</main>
</template>

<script>
import DonutFudge from '../../../assets/images/home/DonutFudge.jpg'
import OreoFudge from '../../../assets/images/home/OreoFudge.jpg'
import Brownie from '../../../assets/images/home/Brownie.jpg'
import TaniaImage from '../../../assets/images/home/TaniaImage.jpg'

export default {
    data() {
        return {
            HomeImages: [
                DonutFudge,
                OreoFudge,
                Brownie
            ],
            HomeImageMobile: OreoFudge,
            TaniaImage: TaniaImage,
            ReviewItems: {
                ReviewOne: {
                    ReviewItem: "\"For lovely treats, great service delivery try Tania's treats. She managed to delivery on short notice, freshly baked\" - Marietjie Pienaar"
                },
                ReviewTwo: {
                    ReviewItem: "\"I highly recommend. My Husband said that this was one of the best Father's Day gifts he ever received.  Thank you.\" - Audrey Smit Conlin"
                },
                ReviewThree: {
                    ReviewItem: "\"Most amazing fudge I've ever tasted!!!\" - Chantál Fourie"
                }
            }
        }
    }
}
</script>

<style lang="scss">
@import "../../../assets/GlobalCss.scss";

.L_HomeMainHolder {
    width: 100%;
    height: 100rem;

    @include mobile() {
        height: 110rem;
    }
}

.L_HomeMainImageHolder {
    width: 100%;
    height: 40%;

    @include mobile() {
        height: 20%;
    }
}

.L_HomeImage {
    width: 33.33%;
    height: 100%;

    @include mobile() {
        display: none;
    }
}

.L_HomeImageMobile {
    display: none;

    @include mobile() {
        display: flex;
        width: 100%;
        height: 100%;
        background-size: 100% 100%;
    }
}

.L_HomeDescriptionHolder {
    width: 100%;
    height: 40%;
    align-items: center;
    justify-content: space-around;

    @include mobile() {
        height: 55%;
        margin-top: 1.5rem;
    }
}

.L_HomeDescriptionHeading {
    margin-top: 2rem;

    @include mobile() {
        margin-top: 0;
        margin-bottom: 1rem;
    }
}

.L_HomeDescriptionImageText {
    width: 95%;
    height: 100%;
    display: flex;
    flex-flow: row nowrap;

    @include mobile() {
        flex-flow: column nowrap;
    }
}

.L_HomeDescriptionImage,
.L_HomeDescriptionText {
    width: 50%;
    height: 100%;
    align-items: center;
    justify-content: center;
    display: flex;
    flex-flow: row nowrap;

    @include mobile() {
        width: 100%;
        height: 50%;
    }
}

.L_TaniaImage {
    width: 50%;
    height: 85%;
    border: #F3CBBB solid .2rem;

    @include mobile() {
        width: 60%;
        height: 95%;
    }
}

.L_HomeDescriptionText {
    width: 45%;
    text-align: center;

    @include mobile() {
        width: 100%;
        height: 60%;
    }
}

.L_ReviewHolder {
    width: 100%;
    height: 20%;
    background-color: #F3CBBB;
    align-items: center;
    justify-content: space-around;

    @include mobile() {
        height: 29%;
    }
}

.L_ReviewHeading {
    width: 100%;
    height: 10%;
    justify-content: center;
    margin-top: 1rem;
}

.L_ReviewItems {
    width: 100%;
    height: 60%;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    align-items: center;

    @include mobile() {
        flex-flow: column nowrap;
        height: 90%;
    }
}

.L_ReviewItem {
    width: 25%;
    height: 100%;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #ffffff;
    border-radius: 0.5rem;
    box-shadow: 5px 5px #888888;
    padding-left: 1rem;
    padding-right: 1rem;

    @include mobile() {
        width: 85%;
        height: 28%;
    }
}
</style>
